import React from "react";

function CreditCostSummaryIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#credit-cost-summary-icon-clip)">
        <path
          d="M14.9896 1.6655H4.99655C4.07672 1.6655 3.33105 2.41117 3.33105 3.331V16.655C3.33105 17.5748 4.07672 18.3205 4.99655 18.3205H14.9896C15.9094 18.3205 16.6551 17.5748 16.6551 16.655V3.331C16.6551 2.41117 15.9094 1.6655 14.9896 1.6655Z"
          stroke="#FA9C03"
          strokeWidth="1.6655"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66211 4.9965H13.3241"
          stroke="#FA9C03"
          strokeWidth="1.6655"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3242 11.6585V14.9895"
          stroke="#FA9C03"
          strokeWidth="1.6655"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3242 8.3275H13.3325"
          stroke="#FA9C03"
          strokeWidth="1.6655"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99316 8.3275H10.0015"
          stroke="#FA9C03"
          strokeWidth="1.6655"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66211 8.3275H6.67044"
          stroke="#FA9C03"
          strokeWidth="1.6655"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99316 11.6585H10.0015"
          stroke="#FA9C03"
          strokeWidth="1.6655"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66211 11.6585H6.67044"
          stroke="#FA9C03"
          strokeWidth="1.6655"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99316 14.9895H10.0015"
          stroke="#FA9C03"
          strokeWidth="1.6655"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66211 14.9895H6.67044"
          stroke="#FA9C03"
          strokeWidth="1.6655"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="credit-cost-summary-icon-clip">
          <rect width="19.986" height="19.986" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CreditCostSummaryIcon;
